$(document).ready(function () {
    const rol_user = $("#item_rol").val()
    $("#div_remote_access_id").hide()
    $("#div_remote_access_password").hide()

    if (window.location.href.indexOf('scrollToBottom') !== -1) {
        document.addEventListener('DOMContentLoaded', function () {
            window.scrollTo(0, document.body.scrollHeight);
        });
    }

    $("#requests-ti-table").dataTable({
        'processing': true,
        'serverSide': true,
        'ajax': 'get-request-by-ti',
        'columns': [
            {data: 'order'},
            {data: 'user_request.name'},
            {data: 'name'},
            {data: 'problem'},
            {data: 'get_state_for_request.description'},
            {data: 'user_assigned.name'},
            {data: 'request_branch.name'},
            {data: 'date'},
        ],
        order: [[1,'desc']],
        "columnDefs": [
            {
                "targets": 8,
                "render": function (data, type, row, meta) {
                    console.log(row)
                    return "<button type='button' target='_blank'" +
                        "class='btn btn-corporativo m-1 btn-sm soporte-ti-detail-uuid' " +
                        "data-uuid='" + row.uuid + "' " +
                        "data-assigned_user_id='" + row.assigned_user_id + "' " +
                        ">" +
                        "<i class='fa-solid fa-check-to-slot'></i>" +
                        "</button> " +
                        "<button type='button'" +
                        "class='btn btn-corporativo m-1 btn-sm preview '" +
                        ">" +
                        "<i class='fa-solid fa-magnifying-glass'></i>" +
                        "</button> " + btn_selecc_user(row,row.status_code)
                    /*+ btn_request_cancel(row)*/
                }
            }],
        "language": {
            "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json"
        },
    })

    $("#requests-ti-finished-table").dataTable({
        'processing': true,
        'serverSide': true,
        'ajax': 'get-request-finished',
        'columns': [
            {data: 'order'},
            {data: 'user_request.name'},
            {data: 'name'},
            {data: 'problem'},
            {data: 'get_state_for_request.description'},
            {data: 'user_assigned.name'},
            {data: 'request_branch.name'},
            {data: 'date'},
        ],
        "order": [[ 0, "desc" ]],
        "columnDefs": [
            {
                "targets": 8,
                "render": function (data, type, row, meta) {
                    return "<button type='button' target='_blank'" +
                        "class='btn btn-corporativo btn-sm m-1 soporte-ti-finished-detail-uuid' " +
                        "data-uuid='" + row.uuid + "' " +
                        "data-assigned_user_id='" + row.assigned_user_id + "' " +
                        ">" +
                        "<i class='fa-solid fa-check-to-slot'></i>" +
                        "</button> " +
                        "<button type='button'" +
                        "class='btn btn-corporativo btn-sm m-1 preview '" +
                        ">" +
                        "<i class='fa-solid fa-magnifying-glass'></i>" +
                        "</button> " + btn_selecc_user(row,row.status_code)
                    /*+ btn_request_cancel(row)*/
                }
            }],
        "language": {
            "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json"
        },
    })

    $("#requests-ti-cancelled-table").dataTable({
        'processing': true,
        'serverSide': true,
        'ajax': 'get-request-cancelled',
        'columns': [
            {data: 'order'},
            {data: 'user_request.name'},
            {data: 'problem'},
            {data: 'get_state_for_request.description'},
            {data: 'user_assigned.name'},
            {data: 'request_branch.name'},
            {data: 'date'},
        ],
        "columnDefs": [
            {
                "targets": 7,
                "render": function (data, type, row, meta) {
                    console.log(row)
                    return "<button type='button' target='_blank'" +
                        "class='btn btn-corporativo btn-sm soporte-ti-cancelled-detail-uuid' " +
                        "data-uuid='" + row.uuid + "' " +
                        "data-assigned_user_id='" + row.assigned_user_id + "' " +
                        ">" +
                        "<i class='fa-solid fa-check-to-slot'></i>" +
                        "</button> " +
                        "<button type='button'" +
                        "class='btn btn-corporativo btn-sm preview '" +
                        ">" +
                        "<i class='fa-solid fa-magnifying-glass'></i>" +
                        "</button> " + btn_selecc_user(row,row.status_code)
                    /*+ btn_request_cancel(row)*/
                }
            }],
        "language": {
            "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json"
        },
    })

    $("#requests-ti-table tbody").on('click', '.soporte-ti-detail-uuid', function () {
        let assigned_user_id = $(this).data('assigned_user_id')
        let uuid = $(this).data('uuid')
        let pathname = $(location).attr('origin');
        if (assigned_user_id == 2) {
            Swal.fire({
                title: '¿ Estas seguro ?',
                text: "Seras asignado a esta solicitud ",
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: "Cancelar",
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, aceptar!'
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.href = pathname + "/soporte/ti/uuid/" + uuid;
                    window.location.href += '#scrollToBottom';
                }
            })
        } else {
            window.location.href = pathname + "/soporte/ti/uuid/" + uuid;
        }
    })

    $("#requests-ti-cancelled-table tbody").on('click', '.soporte-ti-cancelled-detail-uuid', function () {
        let assigned_user_id = $(this).data('assigned_user_id')
        let uuid = $(this).data('uuid')
        let pathname = $(location).attr('origin');
        window.location.href = pathname + "/soporte/ti/uuid/" + uuid;
        window.location.href += '#scrollToBottom';
    })

    $("#requests-ti-finished-table tbody").on('click', '.soporte-ti-finished-detail-uuid', function () {
        let assigned_user_id = $(this).data('assigned_user_id')
        let uuid = $(this).data('uuid')
        let pathname = $(location).attr('origin');
        if (assigned_user_id == 2) {
            Swal.fire({
                title: '¿ Estas seguro ?',
                text: "Seras asignado a esta solicitud ",
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: "Cancelar",
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, aceptar!'
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.href = pathname + "/soporte/ti/uuid/" + uuid;
                    window.location.href += '#scrollToBottom';
                }
            })
        } else {
            window.location.href = pathname + "/soporte/ti/uuid/" + uuid;
        }
    })

    $("#item-software_access").on('change', function (e) {
        e.preventDefault()
        let value = $(this).val()
        if (value === "N/A") {
            $("#div_remote_access_id").hide()
            $("#div_remote_access_password").hide()
            $("#item-software_access_id").val('')
            $("#item-remote_access_password").val('')
        } else {
            $(".text-option-access").html(value)
            $("#div_remote_access_id").show()
            $("#div_remote_access_password").show()
        }
    })

    $("#requests-ti-table tbody").on('click','.preview',function (){
        let list_request = $("#requests-ti-table").DataTable();
        let rowData = list_request.row($(this).parents('tr')).data();
        $("#modal-preview").modal('show')
        $.each(rowData, function (index,value){
            if(index == "request_branch") {
                $(".value_branch").html(value.name)
            }
            $(".value_"+index).html(value)
        })
    })

    $("#requests-ti-table tbody").on('click','.assign_user',function (e){
        e.preventDefault()
        $(".value_uuid").val($(this).data('uuid'))
        $("#modal-assign-users").modal('show')
    })

    $("#form-assign_user").on('submit', function (e){
        e.preventDefault()
        $.LoadingOverlay("show", window.loadingOverlayOptions);
        let data = new FormData(this)
        $.ajax({
            url: "assign_user",
            type: 'POST',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                setTimeout(function () {
                    $.LoadingOverlay("hide")
                    $("#modal-assign-users").modal('hide')
                    if (response.type == "success") {
                        alertSuccess(response.msg)
                        $("#requests-ti-table").DataTable().ajax.reload()
                    }
                    if (response.type == "error") {
                        alertError(response.msg)
                    }
                }, 1000)
            }, error: function (errors, xhr, status,) {
                $("#modal-request").modal('hide')
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).html(value)
                });
            }
        });
    })

    $("#form-time-line-ti").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData()
        const file = document.getElementById('item-file').files[0];
        let route = "/soporte/detalle/add-detail-to-ticket"
        data.append('uuid', $("#item-uuid").val());
        data.append('comment_timeline', $("#comment_timeline").val());
        data.append('file', file)
        sendData(data, route)
    })

    function sendData(data, route) {
        $.LoadingOverlay("show", window.loadingOverlayOptions);
        $.ajax({
            url: route,
            type: 'POST',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                setTimeout(function () {
                    $.LoadingOverlay("hide")
                    alertSuccess(response.msg)
                    document.getElementById('div_timeline').innerHTML = response.view;
                    $("#item-file").val('')
                    $("#comment_timeline").val('')
                }, 1000)
            }, error: function (errors, xhr, status,) {
                $("#modal-request").modal('hide')
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).html(value)
                });
            }
        });
    }

    function btn_selecc_user(row,status_code) {
        if (rol_user == "Administrador") {
            if (status_code == "created") {
                return "<button type='button' data-uuid="+ row.uuid+" class='btn-sm m-1 btn btn-corporativo btn-sm assign_user ' >" +
                    "<i class='fa-solid fa-users'></i>" +
                    "</button> "
            }
        }
        return  "";
    }
})
